export default __webpack_public_path__ + "static/media/txt1_pc@2x.e86ab226.png";